import { useAuth } from '../contexts/AuthContext';
import { Link } from 'react-router-dom';
import { Bot, Sparkles, Users, DollarSign, Settings, Linkedin } from 'lucide-react';
import Layout from '../components/Layout';

export default function Dashboard() {
  const { isAdmin } = useAuth();

  return (
    <Layout>
    <div className="min-h-screen bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="mb-8">
          <h1 className="text-3xl font-bold text-gray-900 mb-2">Welcome back!</h1>
          <p className="text-gray-600">Let's optimize your career.</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          <Link
            to="/coach"
            className="md:col-span-2 bg-gradient-to-br from-blue-600 to-indigo-700 rounded-xl shadow-sm border border-gray-200 p-6 hover:shadow-md transition"
          >
            <div className="w-12 h-12 bg-white/20 rounded-lg flex items-center justify-center mb-4">
              <Bot className="w-6 h-6 text-white" />
            </div>
            <h3 className="text-lg font-bold text-white mb-2">AI Resume Coach</h3>
            <p className="text-blue-100 text-sm">
              Your personal coach researches companies, interviews you for the details that matter, and writes a resume that gets interviews.
            </p>
          </Link>

          <Link
            to="/linkedin"
            className="bg-white rounded-xl shadow-sm border border-gray-200 p-6 hover:shadow-md transition"
          >
            <div className="w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center mb-4">
              <Linkedin className="w-6 h-6 text-blue-600" />
            </div>
            <h3 className="text-lg font-bold text-gray-900 mb-2">LinkedIn Profile</h3>
            <p className="text-gray-600 text-sm">
              Generate an optimized LinkedIn profile from your resume with keyword-rich content.
            </p>
          </Link>

          <Link
            to="/content-campaigns"
            className="bg-white rounded-xl shadow-sm border border-gray-200 p-6 hover:shadow-md transition"
          >
            <div className="w-12 h-12 bg-purple-100 rounded-lg flex items-center justify-center mb-4">
              <Sparkles className="w-6 h-6 text-purple-600" />
            </div>
            <h3 className="text-lg font-bold text-gray-900 mb-2">Content Campaigns</h3>
            <p className="text-gray-600 text-sm">
              Generate 2-4 weeks of authority-building LinkedIn content based on your expertise.
            </p>
          </Link>

          <Link
            to="/network-scripts"
            className="bg-white rounded-xl shadow-sm border border-gray-200 p-6 hover:shadow-md transition"
          >
            <div className="w-12 h-12 bg-green-100 rounded-lg flex items-center justify-center mb-4">
              <Users className="w-6 h-6 text-green-600" />
            </div>
            <h3 className="text-lg font-bold text-gray-900 mb-2">Network Scripts</h3>
            <p className="text-gray-600 text-sm">
              Create personalized outreach messages to connect with decision makers.
            </p>
          </Link>

          <Link
            to="/financial-planning"
            className="bg-white rounded-xl shadow-sm border border-gray-200 p-6 hover:shadow-md transition"
          >
            <div className="w-12 h-12 bg-yellow-100 rounded-lg flex items-center justify-center mb-4">
              <DollarSign className="w-6 h-6 text-yellow-600" />
            </div>
            <h3 className="text-lg font-bold text-gray-900 mb-2">Financial Planning</h3>
            <p className="text-gray-600 text-sm">
              Explore our Financial Planning Track for qualified clients.
            </p>
          </Link>

          {isAdmin && (
            <Link
              to="/admin/prompts"
              className="bg-gradient-to-br from-red-50 to-orange-50 rounded-xl shadow-sm border border-red-200 p-6 hover:shadow-md transition"
            >
              <div className="w-12 h-12 bg-red-100 rounded-lg flex items-center justify-center mb-4">
                <Settings className="w-6 h-6 text-red-600" />
              </div>
              <h3 className="text-lg font-bold text-gray-900 mb-2">Admin: AI Prompts</h3>
              <p className="text-gray-600 text-sm">
                Manage and edit all AI prompts across the platform.
              </p>
            </Link>
          )}
        </div>
      </div>
    </div>
    </Layout>
  );
}
